import {z} from "zod";

import {OrderFields, OrderSummaryFields} from "./fields";
import {EntityWithIdFields} from "../../../types";
import {OrderStatusTypes} from "./enum";

export const schemaOrder = z.object({
    [OrderFields.Receiver]: z.string(),
    [OrderFields.Address]: z.string(),
    [OrderFields.Items]: z.string(),
    [OrderFields.StatusCode]: z.nativeEnum(OrderStatusTypes),
    [OrderFields.StatusDesc]: z.string(),
    [OrderFields.OrderDate]: z.coerce.date().nullable(),
    [OrderFields.DeliveryDate]: z.coerce.date().nullable(),
    [OrderFields.User]: z.number(),
    [OrderFields.DisplayOrder]: z.number(),
    [OrderFields.Observations]: z.string().nullable(),
    [OrderFields.InvoiceNumber]: z.string().nullable().optional(),
    [OrderFields.DeliveryNote]: z.string().nullable().optional(),
})

export const schemaOrderView = schemaOrder.extend({
    [EntityWithIdFields.Id]: z.number(),
})

export type OrderViewDTO = z.infer<typeof schemaOrderView>

export const schemaOrderUpdate = z.object({
    [OrderFields.Receiver]: z.string(),
    [OrderFields.Address]: z.string(),
    [OrderFields.Items]: z.string(),
    [OrderFields.StatusCode]: z.nativeEnum(OrderStatusTypes),
    [OrderFields.DeliveryDate]: z.coerce.date().nullable(),
    [OrderFields.InvoiceNumber]: z.string().nullable().optional(),
    [OrderFields.DeliveryNote]: z.string().nullable().optional(),
    [OrderFields.Observations]: z.string().nullable().optional(),
})

export type OrderUpdateDTO = z.infer<typeof schemaOrderUpdate>


export const OrderOptionSchema = z.object({
    [OrderFields.StatusCode]: z.nativeEnum(OrderStatusTypes),
    [OrderFields.StatusDesc]: z.string(),
});

export type OrderOption = z.infer<typeof OrderOptionSchema>;

export enum OrderHistoryFields {
    Date = 'fecha'
}

export const OrderHistorySchema = z.object({
    [OrderFields.StatusCode]: z.nativeEnum(OrderStatusTypes),
    [OrderFields.StatusDesc]: z.string(),
    [OrderHistoryFields.Date]: z.coerce.date(),
})

export type OrderHistory = z.infer<typeof OrderHistorySchema>

export const schemaOrderSummary = z.object({
    [OrderSummaryFields.PendingQuantity]: z.number(),
    [OrderSummaryFields.DelayedQuantity]: z.number(),
    [OrderSummaryFields.DeliveredCurrentMonth]: z.number(),
    [OrderSummaryFields.DeliveredPreviousMonth]: z.number(),
    [OrderSummaryFields.UnbilledQuantity]: z.number(),
});

export type OrderSummary = z.infer<typeof schemaOrderSummary>;